export default {"src":"/_next/static/media/3-today-logo.759f4916.svg","height":30,"width":39};